import { GraphQLResolveInfo, SelectionSetNode, FieldNode } from 'graphql';
import { ResolverContext } from '@graphql/types/context';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
export * from '@sdk/__generated__/global-types';

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type ArticleColor = {
  __typename: 'ArticleColor';
  articleId: Scalars['Int'];
  colorId: Scalars['Int'];
  colorName: Scalars['String'];
  sizes: Array<Maybe<Size>>;
};

export type BoxQuantity = {
  __typename: 'BoxQuantity';
  boxCode: Maybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  size: Scalars['String'];
};

export type Brand = {
  __typename: 'Brand';
  id: Scalars['Int'];
  name: Scalars['String'];
  sku: Array<Maybe<ArticleColor>>;
};

export type BrandColorInput = {
  season: Scalars['String'];
  user: User;
};

/** Customer */
export type Customer = {
  __typename: 'Customer';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  loggedIn: Maybe<Scalars['Boolean']>;
  season: Maybe<Scalars['String']>;
  seasons: Array<Season>;
  username: Scalars['String'];
};

/** Group */
export type Group = {
  __typename: 'Group';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupFilters = {
  group: Scalars['Int'];
};

export type GroupsInput = {
  user: Scalars['String'];
};

export enum LoginType {
  /** Agents */
  AGENTE = 'AGENTE',
  /** AS400 User */
  AS400 = 'AS400',
  /** Clients */
  CLIENTE = 'CLIENTE',
  /** Employee */
  EMPLEADO = 'EMPLEADO',
  /** Intranet */
  INTRANET = 'INTRANET',
  /** AS400 */
  LOGIN_400 = 'LOGIN_400',
  /** Mayoral Workshops */
  TALLER = 'TALLER',
  /** Boston Workshops */
  TALLERB = 'TALLERB',
  TALLERB_R = 'TALLERB_R',
  /** Missa Workshops */
  TALLERM = 'TALLERM',
  TALLERM_R = 'TALLERM_R',
  TALLER_R = 'TALLER_R',
  /** Mayoral Shops */
  TIENDA = 'TIENDA',
  /** Boston Shops */
  TIENDAB = 'TIENDAB',
  /** Mayoral Online */
  USER_ON = 'USER_ON',
  /** WSC */
  WSC = 'WSC',
}

export type Mutation = {
  __typename: 'Mutation';
  closePackingList: Maybe<Scalars['Boolean']>;
  deletePackingBox: Maybe<Scalars['Boolean']>;
  /** Login with username / password */
  login: Maybe<Session>;
  /** Logout current customer session */
  logout: Maybe<Scalars['String']>;
  packing: PackingStatus;
  packingBoxDetails: Maybe<Scalars['Boolean']>;
  /** Refresh current customer session */
  refreshTokens: Maybe<Session>;
  registerDocument: Maybe<Scalars['Boolean']>;
  repeatBoxDetails: Maybe<Scalars['Boolean']>;
  updatePassword: Maybe<Scalars['String']>;
};

export type MutationclosePackingListArgs = {
  data: PackingListInput;
};

export type MutationdeletePackingBoxArgs = {
  data: PackingBoxInput;
};

export type MutationloginArgs = {
  password: Scalars['String'];
  type: LoginType;
  username: Scalars['String'];
};

export type MutationpackingArgs = {
  data: PackingBase;
};

export type MutationpackingBoxDetailsArgs = {
  data: PackingBoxDetailsInput;
};

export type MutationregisterDocumentArgs = {
  data: RegisterDocumentInput;
};

export type MutationrepeatBoxDetailsArgs = {
  data: RepeatBoxDetailsInput;
};

export type MutationupdatePasswordArgs = {
  data: WorkshopLoginRequest;
};

export type Navigation = {
  __typename: 'Navigation';
  icon: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  items: Array<NavigationUIItem>;
  label: Scalars['String'];
};

/** Navigation */
export type NavigationFilters = {
  group?: InputMaybe<Scalars['Int']>;
};

export type NavigationInput = {
  filters?: InputMaybe<NavigationFilters>;
  user: User;
};

export type NavigationItem = {
  __typename: 'NavigationItem';
  id: Scalars['Int'];
  name: Scalars['String'];
  options: Array<Maybe<NavigationOption>>;
};

export type NavigationOption = {
  __typename: 'NavigationOption';
  active: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  season: Scalars['String'];
  show: Scalars['String'];
  url: Scalars['String'];
};

export type NavigationUIItem = {
  __typename: 'NavigationUIItem';
  href: Maybe<Scalars['String']>;
  icon: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  label: Scalars['String'];
  order: Maybe<Scalars['Int']>;
};

export enum PackingAction {
  ADD = 'ADD',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
}

export type PackingBase = {
  action: PackingAction;
  boxesTotal?: InputMaybe<Scalars['Int']>;
  closingDate?: InputMaybe<Scalars['Int']>;
  deliveryDate: Scalars['Int'];
  etdDate: Scalars['Int'];
  garmentsTotal: Scalars['Int'];
  hangingTotal?: InputMaybe<Scalars['Int']>;
  packingNumber: Scalars['Int'];
  reference: Scalars['String'];
  transportDetails?: InputMaybe<Scalars['String']>;
  transportMode?: InputMaybe<TransportMode>;
};

export type PackingBox = {
  __typename: 'PackingBox';
  boxNumber: Scalars['Int'];
  brand: Scalars['Int'];
  color: Scalars['Int'];
  grossWeight: Scalars['Int'];
  height: Scalars['Int'];
  length: Scalars['Int'];
  netWeight: Scalars['Int'];
  quantities: Maybe<Array<Maybe<BoxQuantity>>>;
  width: Scalars['Int'];
};

export type PackingBoxDetailsInput = {
  boxNumber: Scalars['Int'];
  brand: Scalars['Int'];
  color: Scalars['Int'];
  height: Scalars['Int'];
  length: Scalars['Int'];
  packingNumber: Scalars['Int'];
  sizes: Array<SizeBoxDetails>;
  width: Scalars['Int'];
};

export type PackingBoxInput = {
  boxNumber: Scalars['Int'];
  packingNumber: Scalars['Int'];
};

export type PackingDetails = {
  __typename: 'PackingDetails';
  boxes: Maybe<Array<Maybe<PackingBox>>>;
};

export type PackingHeader = {
  __typename: 'PackingHeader';
  boxesTotal: Scalars['Int'];
  closingDate: Scalars['Int'];
  creationDate: Scalars['Int'];
  deliveryDate: Scalars['Int'];
  documents: Array<Scalars['String']>;
  etdDate: Scalars['Int'];
  garmentsTotal: Scalars['Int'];
  hangingTotal: Scalars['Int'];
  importationDate: Scalars['Int'];
  packingNumber: Scalars['Int'];
  reference: Scalars['String'];
  status: PackingState;
  transport: Maybe<TransportDetails>;
};

export type PackingList = {
  __typename: 'PackingList';
  details: Maybe<PackingDetails>;
  header: Maybe<PackingHeader>;
};

/** Packing */
export enum PackingListDetails {
  HIDE = 'HIDE',
  SHOW = 'SHOW',
}

export type PackingListFilter = {
  detailsFilters?: InputMaybe<PackingListDetails>;
  packingNumberFilter?: InputMaybe<Scalars['Int']>;
};

export type PackingListInput = {
  packingNumber: Scalars['Int'];
};

export type PackingListRequest = {
  filters?: InputMaybe<PackingListFilter>;
  season: Scalars['String'];
};

export type PackingPDF = {
  __typename: 'PackingPDF';
  pdf: Scalars['String'];
};

export enum PackingState {
  CLOSED = 'CLOSED',
  IMPORTED = 'IMPORTED',
  OPEN = 'OPEN',
}

export type PackingStatus = {
  __typename: 'PackingStatus';
  packingNumber: Maybe<Scalars['Int']>;
  status: PackingState;
};

export type Password = {
  __typename: 'Password';
  password: Scalars['String'];
};

export type PasswordFilter = {
  password: Scalars['String'];
};

export type Query = {
  __typename: 'Query';
  brandColor: Array<Maybe<Brand>>;
  credentials: Password;
  customer: Customer;
  groups: Array<Maybe<Group>>;
  navigation: Array<Navigation>;
  packingList: Array<Maybe<PackingList>>;
  packingPDF: PackingPDF;
  workshops: Array<Maybe<Workshop>>;
};

export type QuerybrandColorArgs = {
  data: BrandColorInput;
};

export type QuerycredentialsArgs = {
  data: WorkshopLoginRequest;
};

export type QuerygroupsArgs = {
  data: GroupsInput;
};

export type QuerynavigationArgs = {
  data: NavigationInput;
};

export type QuerypackingListArgs = {
  data: PackingListRequest;
};

export type QuerypackingPDFArgs = {
  data: PackingListInput;
};

export type QueryworkshopsArgs = {
  data: WorkshopsInput;
};

export type RegisterDocumentInput = {
  action: PackingAction;
  document: Scalars['String'];
  packingNumber: Scalars['Int'];
};

export type RepeatBoxDetailsInput = {
  boxFrom: Scalars['Int'];
  boxTo: Scalars['Int'];
  boxesRange?: InputMaybe<Array<Scalars['Int']>>;
  brand: Scalars['Int'];
  color: Scalars['Int'];
  height: Scalars['Int'];
  length: Scalars['Int'];
  order?: InputMaybe<Scalars['Int']>;
  packingNumber: Scalars['Int'];
  quantity: Scalars['Int'];
  size: Scalars['Int'];
  width: Scalars['Int'];
};

/** Seasons */
export type Season = {
  __typename: 'Season';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type Session = {
  __typename: 'Session';
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export type Size = {
  __typename: 'Size';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type SizeBoxDetails = {
  boxCode?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  size: Scalars['Int'];
};

export type TransportDetails = {
  __typename: 'TransportDetails';
  identifier: Maybe<Scalars['String']>;
  type: Maybe<TransportMode>;
};

export enum TransportMode {
  AIR = 'AIR',
  ROAD = 'ROAD',
  SEA = 'SEA',
}

/** User Common Fields */
export type User = {
  language?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Workshop */
export type Workshop = {
  __typename: 'Workshop';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type WorkshopLoginRequest = {
  filters?: InputMaybe<PasswordFilter>;
  user: User;
  workshop: Scalars['Int'];
};

export type WorkshopsInput = {
  filters: GroupFilters;
  user: User;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string | ((fieldNode: FieldNode) => SelectionSetNode);
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> =
  | LegacyStitchingResolver<TResult, TParent, TContext, TArgs>
  | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  ArticleColor: ResolverTypeWrapper<ArticleColor>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BoxQuantity: ResolverTypeWrapper<BoxQuantity>;
  Brand: ResolverTypeWrapper<Brand>;
  BrandColorInput: BrandColorInput;
  Customer: ResolverTypeWrapper<Customer>;
  Group: ResolverTypeWrapper<Group>;
  GroupFilters: GroupFilters;
  GroupsInput: GroupsInput;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  LoginType: LoginType;
  Mutation: ResolverTypeWrapper<{}>;
  Navigation: ResolverTypeWrapper<Navigation>;
  NavigationFilters: NavigationFilters;
  NavigationInput: NavigationInput;
  NavigationItem: ResolverTypeWrapper<NavigationItem>;
  NavigationOption: ResolverTypeWrapper<NavigationOption>;
  NavigationUIItem: ResolverTypeWrapper<NavigationUIItem>;
  PackingAction: PackingAction;
  PackingBase: PackingBase;
  PackingBox: ResolverTypeWrapper<PackingBox>;
  PackingBoxDetailsInput: PackingBoxDetailsInput;
  PackingBoxInput: PackingBoxInput;
  PackingDetails: ResolverTypeWrapper<PackingDetails>;
  PackingHeader: ResolverTypeWrapper<PackingHeader>;
  PackingList: ResolverTypeWrapper<PackingList>;
  PackingListDetails: PackingListDetails;
  PackingListFilter: PackingListFilter;
  PackingListInput: PackingListInput;
  PackingListRequest: PackingListRequest;
  PackingPDF: ResolverTypeWrapper<PackingPDF>;
  PackingState: PackingState;
  PackingStatus: ResolverTypeWrapper<PackingStatus>;
  Password: ResolverTypeWrapper<Password>;
  PasswordFilter: PasswordFilter;
  Query: ResolverTypeWrapper<{}>;
  RegisterDocumentInput: RegisterDocumentInput;
  RepeatBoxDetailsInput: RepeatBoxDetailsInput;
  Season: ResolverTypeWrapper<Season>;
  Session: ResolverTypeWrapper<Session>;
  Size: ResolverTypeWrapper<Size>;
  SizeBoxDetails: SizeBoxDetails;
  String: ResolverTypeWrapper<Scalars['String']>;
  TransportDetails: ResolverTypeWrapper<TransportDetails>;
  TransportMode: TransportMode;
  User: User;
  Workshop: ResolverTypeWrapper<Workshop>;
  WorkshopLoginRequest: WorkshopLoginRequest;
  WorkshopsInput: WorkshopsInput;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  ArticleColor: ArticleColor;
  Boolean: Scalars['Boolean'];
  BoxQuantity: BoxQuantity;
  Brand: Brand;
  BrandColorInput: BrandColorInput;
  Customer: Customer;
  Group: Group;
  GroupFilters: GroupFilters;
  GroupsInput: GroupsInput;
  Int: Scalars['Int'];
  Mutation: {};
  Navigation: Navigation;
  NavigationFilters: NavigationFilters;
  NavigationInput: NavigationInput;
  NavigationItem: NavigationItem;
  NavigationOption: NavigationOption;
  NavigationUIItem: NavigationUIItem;
  PackingBase: PackingBase;
  PackingBox: PackingBox;
  PackingBoxDetailsInput: PackingBoxDetailsInput;
  PackingBoxInput: PackingBoxInput;
  PackingDetails: PackingDetails;
  PackingHeader: PackingHeader;
  PackingList: PackingList;
  PackingListFilter: PackingListFilter;
  PackingListInput: PackingListInput;
  PackingListRequest: PackingListRequest;
  PackingPDF: PackingPDF;
  PackingStatus: PackingStatus;
  Password: Password;
  PasswordFilter: PasswordFilter;
  Query: {};
  RegisterDocumentInput: RegisterDocumentInput;
  RepeatBoxDetailsInput: RepeatBoxDetailsInput;
  Season: Season;
  Session: Session;
  Size: Size;
  SizeBoxDetails: SizeBoxDetails;
  String: Scalars['String'];
  TransportDetails: TransportDetails;
  User: User;
  Workshop: Workshop;
  WorkshopLoginRequest: WorkshopLoginRequest;
  WorkshopsInput: WorkshopsInput;
}>;

export type ArticleColorResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['ArticleColor'] = ResolversParentTypes['ArticleColor'],
> = ResolversObject<{
  articleId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  colorId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  colorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sizes?: Resolver<Array<Maybe<ResolversTypes['Size']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BoxQuantityResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['BoxQuantity'] = ResolversParentTypes['BoxQuantity'],
> = ResolversObject<{
  boxCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrandResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Brand'] = ResolversParentTypes['Brand'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sku?: Resolver<Array<Maybe<ResolversTypes['ArticleColor']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer'],
> = ResolversObject<{
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  loggedIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasons?: Resolver<Array<ResolversTypes['Season']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GroupResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Group'] = ResolversParentTypes['Group'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation'],
> = ResolversObject<{
  closePackingList?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationclosePackingListArgs, 'data'>
  >;
  deletePackingBox?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationdeletePackingBoxArgs, 'data'>
  >;
  login?: Resolver<
    Maybe<ResolversTypes['Session']>,
    ParentType,
    ContextType,
    RequireFields<MutationloginArgs, 'password' | 'type' | 'username'>
  >;
  logout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packing?: Resolver<
    ResolversTypes['PackingStatus'],
    ParentType,
    ContextType,
    RequireFields<MutationpackingArgs, 'data'>
  >;
  packingBoxDetails?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationpackingBoxDetailsArgs, 'data'>
  >;
  refreshTokens?: Resolver<Maybe<ResolversTypes['Session']>, ParentType, ContextType>;
  registerDocument?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationregisterDocumentArgs, 'data'>
  >;
  repeatBoxDetails?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationrepeatBoxDetailsArgs, 'data'>
  >;
  updatePassword?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<MutationupdatePasswordArgs, 'data'>
  >;
}>;

export type NavigationResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Navigation'] = ResolversParentTypes['Navigation'],
> = ResolversObject<{
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['NavigationUIItem']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NavigationItemResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['NavigationItem'] = ResolversParentTypes['NavigationItem'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<Maybe<ResolversTypes['NavigationOption']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NavigationOptionResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['NavigationOption'] = ResolversParentTypes['NavigationOption'],
> = ResolversObject<{
  active?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  season?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  show?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NavigationUIItemResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['NavigationUIItem'] = ResolversParentTypes['NavigationUIItem'],
> = ResolversObject<{
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PackingBoxResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['PackingBox'] = ResolversParentTypes['PackingBox'],
> = ResolversObject<{
  boxNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  brand?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  color?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  grossWeight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  length?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  netWeight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantities?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BoxQuantity']>>>,
    ParentType,
    ContextType
  >;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PackingDetailsResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['PackingDetails'] = ResolversParentTypes['PackingDetails'],
> = ResolversObject<{
  boxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['PackingBox']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PackingHeaderResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['PackingHeader'] = ResolversParentTypes['PackingHeader'],
> = ResolversObject<{
  boxesTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  closingDate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  creationDate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deliveryDate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  etdDate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  garmentsTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hangingTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  importationDate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  packingNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PackingState'], ParentType, ContextType>;
  transport?: Resolver<Maybe<ResolversTypes['TransportDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PackingListResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['PackingList'] = ResolversParentTypes['PackingList'],
> = ResolversObject<{
  details?: Resolver<Maybe<ResolversTypes['PackingDetails']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['PackingHeader']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PackingPDFResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['PackingPDF'] = ResolversParentTypes['PackingPDF'],
> = ResolversObject<{
  pdf?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PackingStatusResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['PackingStatus'] = ResolversParentTypes['PackingStatus'],
> = ResolversObject<{
  packingNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PackingState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PasswordResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Password'] = ResolversParentTypes['Password'],
> = ResolversObject<{
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query'],
> = ResolversObject<{
  brandColor?: Resolver<
    Array<Maybe<ResolversTypes['Brand']>>,
    ParentType,
    ContextType,
    RequireFields<QuerybrandColorArgs, 'data'>
  >;
  credentials?: Resolver<
    ResolversTypes['Password'],
    ParentType,
    ContextType,
    RequireFields<QuerycredentialsArgs, 'data'>
  >;
  customer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  groups?: Resolver<
    Array<Maybe<ResolversTypes['Group']>>,
    ParentType,
    ContextType,
    RequireFields<QuerygroupsArgs, 'data'>
  >;
  navigation?: Resolver<
    Array<ResolversTypes['Navigation']>,
    ParentType,
    ContextType,
    RequireFields<QuerynavigationArgs, 'data'>
  >;
  packingList?: Resolver<
    Array<Maybe<ResolversTypes['PackingList']>>,
    ParentType,
    ContextType,
    RequireFields<QuerypackingListArgs, 'data'>
  >;
  packingPDF?: Resolver<
    ResolversTypes['PackingPDF'],
    ParentType,
    ContextType,
    RequireFields<QuerypackingPDFArgs, 'data'>
  >;
  workshops?: Resolver<
    Array<Maybe<ResolversTypes['Workshop']>>,
    ParentType,
    ContextType,
    RequireFields<QueryworkshopsArgs, 'data'>
  >;
}>;

export type SeasonResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Season'] = ResolversParentTypes['Season'],
> = ResolversObject<{
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SessionResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Session'] = ResolversParentTypes['Session'],
> = ResolversObject<{
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SizeResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Size'] = ResolversParentTypes['Size'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransportDetailsResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['TransportDetails'] = ResolversParentTypes['TransportDetails'],
> = ResolversObject<{
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TransportMode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WorkshopResolvers<
  ContextType = ResolverContext,
  ParentType extends ResolversParentTypes['Workshop'] = ResolversParentTypes['Workshop'],
> = ResolversObject<{
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = ResolverContext> = ResolversObject<{
  ArticleColor?: ArticleColorResolvers<ContextType>;
  BoxQuantity?: BoxQuantityResolvers<ContextType>;
  Brand?: BrandResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  Group?: GroupResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Navigation?: NavigationResolvers<ContextType>;
  NavigationItem?: NavigationItemResolvers<ContextType>;
  NavigationOption?: NavigationOptionResolvers<ContextType>;
  NavigationUIItem?: NavigationUIItemResolvers<ContextType>;
  PackingBox?: PackingBoxResolvers<ContextType>;
  PackingDetails?: PackingDetailsResolvers<ContextType>;
  PackingHeader?: PackingHeaderResolvers<ContextType>;
  PackingList?: PackingListResolvers<ContextType>;
  PackingPDF?: PackingPDFResolvers<ContextType>;
  PackingStatus?: PackingStatusResolvers<ContextType>;
  Password?: PasswordResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Season?: SeasonResolvers<ContextType>;
  Session?: SessionResolvers<ContextType>;
  Size?: SizeResolvers<ContextType>;
  TransportDetails?: TransportDetailsResolvers<ContextType>;
  Workshop?: WorkshopResolvers<ContextType>;
}>;
